// messages for Eye icon for pages in Table of Contents for proposals
import { TBlock } from 'detailsv2/__blocks';
import { ILink } from 'detailsv2/LandingV2/TableOfContents/types';

import { IProposal } from '../../itineraryDetails/types';

const EYE_TOOLTIP_MESSAGES = [
  'Click to hide \npage from client \nfacing proposal',
  'Click to make \nvisible on the client \nfacing proposal',
  'Page is empty \nand won’t be shown \non client facing proposal',
];

export function getEyeTooltipMsg(link: ILink) {
  const tooltipMessageIndex = !link.canBeVisible ? 2 : link.isHidden ? 1 : 0;

  return EYE_TOOLTIP_MESSAGES[tooltipMessageIndex];
}

export type TAnchor = { pageId?: number; blockId?: number };

// Returns anchor for initial scroll position on landing
export function getDefaultAnchor(proposal: IProposal, originalPagePreviewId?: number): TAnchor {
  const anchor: TAnchor = {};

  if (!originalPagePreviewId) return anchor;

  for (const { id, originalId } of proposal.landing.pages) {
    if (originalId === originalPagePreviewId) {
      anchor.pageId = id;

      break;
    }
  }

  if (!anchor.pageId) {
    const tripEvent = proposal.tripEvents.find((t) =>
      t.attachedPages?.map((p) => Number(p.id)).includes(originalPagePreviewId),
    );

    if (tripEvent) {
      for (const page of proposal.landing.pages) {
        const block = (page.blocks as TBlock[]).find((b) => b.meta?.tripEventId === tripEvent.id);

        if (block) {
          anchor.blockId = block.id;

          break;
        }
      }
    }
  }

  return anchor;
}

export function getPageAnchorId(id: number) {
  return String(id);
}

export function getBlockAnchorId(id: number) {
  return `block-id-${id}`;
}
